import React, { useEffect, useState } from 'react';

const Test = () => {
    const [isTabVisible, setIsTabVisible] = useState(true);
  const [isInactive, setIsInactive] = useState(false);
  const [inactiveTime, setInactiveTime] = useState(0);

  // Function to handle when the tab visibility changes
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        // When the tab becomes inactive, start the inactivity timer
        setIsInactive(true);
        setInactiveTime(Date.now()); // Capture the timestamp when the tab was switched
      } else {
        // When the tab becomes active again, reset the warning
        setIsInactive(false);
      }
    };

    // Add event listener for visibility change (tab switch)
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      // Clean up the event listener
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

//   useEffect(())

  // Check if the tab has been inactive for too long
  useEffect(() => {
    let inactivityTimeout: NodeJS.Timeout;

    if (isInactive) {
      inactivityTimeout = setInterval(() => {
        const timeInactive = Date.now() - inactiveTime;
        if (timeInactive > 5000) { // If inactive for more than 5 seconds
          alert("Your test will be automatically submitted because you switched tabs.");
          // Optionally, submit the test here
        }
      }, 1000);
    }

    // Cleanup timeout when component unmounts or if inactivity is reset
    return () => {
      if (inactivityTimeout) {
        clearInterval(inactivityTimeout);
      }
    };
  }, [isInactive, inactiveTime]);
    // useEffect(() => {
    //     const handleBeforeUnload = (event: any) => {
    //         // Custom message will not be shown in most browsers anymore, but the confirmation dialog will still appear.
    //         const message = "Are you sure you want to leave? You have unsaved changes.";

    //         // This is required to trigger the confirmation dialog
    //         event.returnValue = message;

    //         // For some browsers like Chrome, this will be displayed by default
    //         return message;
    //     };

    //     // Add the beforeunload event listener
    //     window.addEventListener('beforeunload', handleBeforeUnload);

    //     // Cleanup the event listener when the component unmounts
    //     return () => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, []);
    // useEffect(() => {
    //     const handleVisibilityChange = () => {
    //         if (document.visibilityState === 'hidden') {
    //             setIsTabVisible(false);
    //             console.log("User switched to a different tab or minimized the browser.");
    //         } else {
    //             setIsTabVisible(true);
    //             console.log("User returned to the tab.");
    //         }
    //     };

    //     document.addEventListener('visibilitychange', handleVisibilityChange);

    //     return () => {
    //         document.removeEventListener('visibilitychange', handleVisibilityChange);
    //     };
    // }, []);
    // useEffect(() => {
    //     const handleBeforeUnload = (event: any) => {
    //         // Custom message shown in the confirmation dialog (Note: modern browsers may not allow custom messages)
    //         const message = "Are you sure you want to leave? You have unsaved changes.";

    //         // This is required to display the confirmation dialog in some browsers
    //         event.returnValue = message;

    //         // For some other browsers (like Chrome), just setting event.returnValue will work
    //         return message;
    //     };

    //     // Attach the event listener when the component mounts
    //     window.addEventListener('beforeunload', handleBeforeUnload);

    //     // Clean up the event listener when the component unmounts
    //     return () => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, []);
    useEffect(() => {
        // Disable new tab and new window keyboard shortcuts
        const disableShortcuts = (e: KeyboardEvent) => {
            if (e.ctrlKey && (e.key === 't' || e.key === 'n'||e.key?.toLowerCase()==='control')) {
                e.preventDefault(); // Prevent opening new tab or new window
                alert("New tabs/windows are disabled during the test.");
            }
        };

        document.addEventListener('keydown', disableShortcuts);

        return () => {
            document.removeEventListener('keydown', disableShortcuts);
        };
    }, []);



    return (
        <div>
            <h1>Prevent Leaving/Closing the Tab</h1>
            <p>Try to leave or close the tab to see the warning.</p>
            <h1>Tab Visibility Tracker</h1>
            <p>Current tab is {isTabVisible ? 'visible' : 'hidden'}</p>
            <div>
                <h1>Tab Switch and Close Confirmation</h1>
                <p>Try to close the tab or navigate away to see the confirmation.</p>
            </div>
             <p>All shortcuts to open new tabs/windows are disabled.</p>
               {/* Optional: Show a warning if the user has switched tabs */}
      {isInactive && (
        <div style={{ color: 'red', fontWeight: 'bold', marginTop: '20px' }}>
          <p>You switched tabs! Your test will be submitted after 5 seconds of inactivity.</p>
        </div>
      )}
        </div>
    );
};

export default Test;
